<!-- @author Shyam @Date 07/11/2025 -->
<div class="topDiv" >
    
<div class="mainContent" >

  <div style="height: 7vh;">
    <div>
      <label i18n="@@spmsUserReg" class="textColour">Source Data Extraction Queries</label>
      <span class="example-spacer"></span>
    </div>
  </div>

  <div style="height: 67vh; overflow: auto; padding-left: 4%; padding-right: 4%;">
    <form novalidate [formGroup]="FormValid" style="width: 100%;">
      
      <!-- SQL Query -->
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline">
            <mat-label>SQL Query</mat-label>
            <textarea matInput type="text" placeholder="SQL Query"
              formControlName="sqlscript__j"
              [(ngModel)]="sqlscripts__j.sqlscript__j" required></textarea>
              <mat-error *ngFor="let validation of
                  validation_messages.sqlscript__j">
                  <span
                    *ngIf="FormValid.get('sqlscript__j').hasError(validation.type)
                    && (FormValid.get('sqlscript__j').dirty ||
                    FormValid.get('sqlscript__j').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Pre Defined SQLScript Query -->
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline">
            <mat-label>Pre Defined sqlscript Query</mat-label>
            <input matInput type="text" placeholder="Pre Defined sqlscript Query"
              formControlName="formated_sqlscript__j"
              [(ngModel)]="sqlscripts__j.formated_sqlscript__j" readonly>
          </mat-form-field>
        </div>
      </div>

       <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <div class="radio-group-container">
            <label class="radio-label">Format Date :</label>
            <div class="radio-group-wrapper">
                <mat-radio-group
              formControlName="automatically_formate"
              [(ngModel)]="sqlscripts__j.automatically_formate"
              class="vertical-radio-group"
            >
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
                 <mat-error *ngFor="let validation of
                  validation_messages.automatically_formate">
                  <span
                    *ngIf="FormValid.get('automatically_formate').hasError(validation.type)
                    && (FormValid.get('automatically_formate').dirty ||
                    FormValid.get('automatically_formate').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
            </div>
          </div>
        </div>
      </div>

       <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline">
            <mat-label>File Name</mat-label>
            <input matInput type="text" placeholder="File Name"
              formControlName="filename__j"
              [(ngModel)]="sqlscripts__j.filename__j" required>
              				  <mat-error *ngFor="let validation of
                  validation_messages.filename__j">
                  <span
                    *ngIf="FormValid.get('filename__j').hasError(validation.type)
                    && (FormValid.get('filename__j').dirty ||
                    FormValid.get('filename__j').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
          </mat-form-field>
        </div>
      </div>
      <!-- Execution Order -->
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline">
            <mat-label>Execution Order</mat-label>
            <input matInput type="text" placeholder="Execution Order"
              formControlName="executionorder__j"
              [(ngModel)]="sqlscripts__j.executionorder__j" required>
              				  <mat-error *ngFor="let validation of
                  validation_messages.executionorder__j">
                  <span
                    *ngIf="FormValid.get('executionorder__j').hasError(validation.type)
                    && (FormValid.get('executionorder__j').dirty ||
                    FormValid.get('executionorder__j').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Query Execution Type -->
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline">
            <mat-label>Query Execution Type</mat-label>
            <!-- <input matInput type="text" placeholder="Query Execution Type"
              formControlName="queryexecutiontype__j"
              [(ngModel)]="sqlscripts__j.queryexecutiontype__j" required> -->
               <mat-select formControlName="queryexecutiontype__j" [(ngModel)]="sqlscripts__j.queryexecutiontype__j"  (selectionChange)="onQueryExecutionChange($event)" >
                      <!-- <span  *ngFor="let data of objectGroupData"> -->
                <mat-option  *ngFor="let data of queryExecutionType"
                  [value]="data.lookupcode">
                  {{data.lookupvalue}}
                </mat-option>
                  </mat-select>
                  <mat-error *ngFor="let validation of
                  validation_messages.queryexecutiontype__j">
                  <span
                    *ngIf="FormValid.get('queryexecutiontype__j').hasError(validation.type)
                    && (FormValid.get('queryexecutiontype__j').dirty ||
                    FormValid.get('queryexecutiontype__j').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
          </mat-form-field>
        </div>
      </div>

      <!-- Attachment Query -->
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <div class="radio-group-container">
            <label class="radio-label">Attachment Query? :</label>
           <div  class="radio-group-wrapper">
             <mat-radio-group
              formControlName="attachmentquery__j"
              [(ngModel)]="sqlscripts__j.attachmentquery__j"
              class="vertical-radio-group"
            >
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
            				  <mat-error *ngFor="let validation of
                  validation_messages.attachmentquery__j">
                  <span
                    *ngIf="FormValid.get('attachmentquery__j').hasError(validation.type)
                    && (FormValid.get('attachmentquery__j').dirty ||
                    FormValid.get('attachmentquery__j').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
           </div>
          </div>
        </div>
      </div>

      <!-- Extraction Type -->
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <div class="radio-group-container">
            <label class="radio-label">Extraction Type :</label>
           <div class="radio-group-wrapper">
             <mat-radio-group
              formControlName="extractiontype__j"
              [(ngModel)]="sqlscripts__j.extractiontype__j"
              class="vertical-radio-group"
            >
              <mat-radio-button value="CsvExtraction">CsvExtraction</mat-radio-button>
              <mat-radio-button value="AttachmentExtraction">AttachmentExtraction</mat-radio-button>
          <!--  
             @modified by Shantanu Ghate
             @Date 28-03-2026
             added the radio button for AuditTrailExtraction
          -->
              <mat-radio-button value="AuditTrailExtraction">AuditTrailExtraction</mat-radio-button>
              <mat-radio-button value="GlobalExtraction">GlobalExtraction</mat-radio-button>
            </mat-radio-group>
            				  <mat-error *ngFor="let validation of
                  validation_messages.extractiontype__j">
                  <span
                    *ngIf="FormValid.get('extractiontype__j').hasError(validation.type)
                    && (FormValid.get('extractiontype__j').dirty ||
                    FormValid.get('extractiontype__j').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
           </div>
          </div>
        </div>
      </div>

      <!-- Is Executable -->
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <div class="radio-group-container">
            <label class="radio-label">Is Executable? :</label>
                <div  class="radio-group-wrapper">
                    <mat-radio-group
              formControlName="isExecutable__j"
              [(ngModel)]="sqlscripts__j.isExecutable__j"
              class="vertical-radio-group"
            >
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
            				  <mat-error *ngFor="let validation of
                  validation_messages.isExecutable__j">
                  <span
                    *ngIf="FormValid.get('isExecutable__j').hasError(validation.type)
                    && (FormValid.get('isExecutable__j').dirty ||
                    FormValid.get('isExecutable__j').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
                </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline">
            <mat-label>Data Source Name</mat-label>
            <!-- <input matInput type="text" placeholder="Data Source Name"
              formControlName="sourceconnectionstring__j"
              [(ngModel)]="sqlscripts__j.sourceconnectionstring__j" required> -->
               <mat-select formControlName="sourceconnectionstring__j" [(ngModel)]="sqlscripts__j.sourceconnectionstring__j"  (selectionChange)="onDataSourceChange($event)" >
                      <!-- <span  *ngFor="let data of objectGroupData"> -->
                <mat-option  *ngFor="let data of dataSourceName"
                  [value]="data">
                  {{data}}
                </mat-option>
                </mat-select>
                	  <mat-error *ngFor="let validation of
                  validation_messages.sourceconnectionstring__j">
                  <span
                    *ngIf="FormValid.get('sourceconnectionstring__j').hasError(validation.type)
                    && (FormValid.get('sourceconnectionstring__j').dirty ||
                    FormValid.get('sourceconnectionstring__j').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline">
            <mat-label>Data Source Type</mat-label>
            <input matInput type="text" placeholder="Data Source Type"
              formControlName="sourcetype__j"
              [(ngModel)]="sqlscripts__j.sourcetype__j" required>
              				  <mat-error *ngFor="let validation of
                  validation_messages.sourcetype__j">
                  <span
                    *ngIf="FormValid.get('sourcetype__j').hasError(validation.type)
                    && (FormValid.get('sourcetype__j').dirty ||
                    FormValid.get('sourcetype__j').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
          </mat-form-field>
        </div>
      </div>    
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
            <mat-form-field appearance="outline" class="dropdown=field">
                <mat-label i18n="@@targetloginusername">
                   Group Name
                </mat-label>
                <mat-select formControlName="objectgroupname" [(ngModel)]="selectedGroup"  (selectionChange)="onObjectGroupChange($event)" >
                      <!-- <span  *ngFor="let data of objectGroupData"> -->
                <mat-option  *ngFor="let data of objectGroupData"
                  [value]="data.objectGroupId"
                >
                {{data.objectGroupName}}
                </mat-option>
                <!-- </span> -->
                 				 
                </mat-select>
                 <mat-error *ngFor="let validation of
                  validation_messages.objectgroupname">
                  <span
                    *ngIf="FormValid.get('objectgroupname').hasError(validation.type)
                    && (FormValid.get('objectgroupname').dirty ||
                    FormValid.get('objectgroupname').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
            </mat-form-field>
        </div>
      </div>
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
            <mat-form-field appearance="outline" class="dropdown=field">
                <mat-label>Object Name</mat-label>
                <mat-select formControlName="objectname" multiple (selectionChange)="onObjectNameChange($event)">

                <!-- <mat-select formControlName="objectname"[(ngModel)]="sqlscripts__j.objectname" multiple (selectionChange)="onObjectNameChange($event)" > -->
                     <!-- <span  > -->
                <mat-option  *ngFor="let data of ObjectsData"
                  [value]="data.id"
                >
                {{data.objectname}}
                </mat-option>
                <!-- </span>  -->
                 	
                </mat-select>
                <mat-error *ngFor="let validation of
                  validation_messages.objectname">
                  <span
                    *ngIf="FormValid.get('objectname').hasError(validation.type)
                    && (FormValid.get('objectname').dirty ||
                    FormValid.get('objectname').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
            </mat-form-field>
        </div>
      </div>

       <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <div class="radio-group-container">
            <label class="radio-label">Set Split Required? :</label>
           <div class="radio-group-wrapper">
             <mat-radio-group
              formControlName="setssplitrequired"
              [(ngModel)]="sqlscripts__j.setssplitrequired"
              class="vertical-radio-group"
            >
              <mat-radio-button value="Yes">Yes</mat-radio-button>
              <mat-radio-button value="No">No</mat-radio-button>
            </mat-radio-group>
            				  <mat-error *ngFor="let validation of
                  validation_messages.setssplitrequired">
                  <span
                    *ngIf="FormValid.get('setssplitrequired').hasError(validation.type)
                    && (FormValid.get('setssplitrequired').dirty ||
                    FormValid.get('setssplitrequired').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
           </div>
          </div>
        </div>
      </div>

       <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <div class="radio-group-container">
            <label class="radio-label">Group Extraction Type :</label>
           <div  class="radio-group-wrapper">
             <mat-radio-group
              formControlName="groupextractiontype"
              [(ngModel)]="sqlscripts__j.groupextractiontype"
              class="vertical-radio-group"
            >
              <mat-radio-button value="Full Data">Full Data</mat-radio-button>
              <mat-radio-button value="Partial Data">Partial Data</mat-radio-button>
            </mat-radio-group>
            				  <mat-error *ngFor="let validation of
                  validation_messages.groupextractiontype">
                  <span
                    *ngIf="FormValid.get('groupextractiontype').hasError(validation.type)
                    && (FormValid.get('groupextractiontype').dirty ||
                    FormValid.get('groupextractiontype').touched)">
                    {{ validation.message }}
                  </span>
                </mat-error>
           </div>
          </div>
        </div>
      </div>

    </form>
  </div>

  <!-- Footer Buttons -->
  <div style="height: 1vh;" >
    <div class="row" style="position: sticky; left: 0; bottom: 0; width: 100%; ">
      <div class="col-lg text-center">
        <div style="text-align: end; ">
          <form novalidate [formGroup]="formValidCheckbox">
            <span *ngIf="showCreateAnother">
              <mat-checkbox formControlName="isCheckboxSelected" [(ngModel)]="isCheckboxSelected"
                style="margin-right:1%" class="mat-checkbox-layout"></mat-checkbox>
              <span>Create another</span>
            </span>

            <button i18n="@@TargetClear" type="button"
              class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              [style.background-color]="backgroundColorButton"
              (click)="saveMethod()"
              style="padding: .3rem 1.6rem; font-size: .85rem; width:150px; color: white;">
              {{this.buttonName}}
            </button>

            <button i18n="@@TargetCancel" type="button"
              class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              (click)="cancel()" [style.background-color]="backgroundColorButton"
              style="padding: .3rem 1.6rem; font-size: .85rem; width:150px; color: white;">Cancel</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

</div>
